import AxiosInstance from "./AxiosInstance.js";

class AdminError {
    constructor(message) {
        this.name = 'AdminError';
        this.stack = new Error(message).stack;
        this.message = message;
    }
}

export function overwriteEnrollments(courseId, emails) {
    return AxiosInstance.post(`/api/courses/${courseId}/enrollment/overwrite`, {emails: emails}).catch(err => {
        if (err.response.data.invalid) {
            if (err.response.data.duplicate.length > 0)
                throw new AdminError(`Os seguintes emails estão duplicados: ${err.response.data.duplicate.join(', ')}`);
            else if (err.response.data.invalid.length > 0)
                throw new AdminError(`Os seguintes emails não existem na base de dados: ${err.response.data.invalid.join(', ')}`);
        }
        throw err;
    })
}

export function overwriteTrainingEnrollments(trainingId, emails) {
    return AxiosInstance.post(`/api/trainings/${trainingId}/enrollment/overwrite`, {emails: emails}).catch(err => {
        if (err.response.data.invalid) {
            if (err.response.data.duplicate.length > 0)
                throw new AdminError(`Os seguintes emails estão duplicados: ${err.response.data.duplicate.join(', ')}`);
            else if (err.response.data.invalid.length > 0)
                throw new AdminError(`Os seguintes emails não existem na base de dados: ${err.response.data.invalid.join(', ')}`);
        }
        throw err;
    })
}

export function toggleAdmin(userId, enable) {
    return AxiosInstance.put(`/api/users/${userId}/admin`, { enable }).then(res => res.data);
}

export function massAccountCreation(users, customPassword, ignoreDuplicates, countryId) {
    return AxiosInstance.post('/api/users/mass-creation', {
        customPassword, ignoreDuplicates, users, countryId
    }).then(res => res.data).catch(err => {
        const { invalid, duplicate, existing } = err.response.data;
        if (invalid)
            throw new AdminError(`Os seguintes emails são inválidos: ${invalid.join(', ')}`);
        else if (duplicate)
            throw new AdminError(`Os seguintes emails estão duplicados: ${duplicate.join(', ')}`);
        else if (existing)
            throw new AdminError( `Os seguintes emails já existem na base de dados ${existing.join(', ')}`);
        else throw err
    });
}

export function generateUsersCSV(fileHeaders) {
    return AxiosInstance.post('/api/users/generate-csv', {fileHeaders}).then(res => res.data).catch(err => {throw err});
}

export function massAccountDeletion(emails) {
    return AxiosInstance.post('/api/users/mass-deletion', { emails }).then(res => res.data.count);
}